import type { BaseComponentProps } from "@q4/nimbus-ui";

export interface ReportBannerProps extends BaseComponentProps {
  userContext?: Record<string, unknown>;
}

export enum ReportBannerClassName {
  Base = "report-banner",
}
